// extracted by mini-css-extract-plugin
module.exports = {"body":"MessengerBody_body__IpPJ4"};